<template>
<div v-if="Access('AreasAdd')" :id="'CookiesDialog_' + DialogIndex" class="CookiesDialogdBody">
  <DialogDisabler v-if="Saving"></DialogDisabler>
  <div class="M-Auto DialogContainer">
    <div class="DialogBody">
      <div class=" D-Flex W-100" style="text-align:left; margin-bottom:15px; white-space: nowrap;">
      </div>
      <!-- Area -------------------------------------- -->
      <div class="CookiesRow">
        <input v-model="Name" :class=" (ErrorsVisibilty & !Name) && 'ErrorBorder' " class="CookiesInput color2" type="Text" :placeholder="LanguageSelector('Area Name', 'اسم المنطقة')" autocomplete="off">
        <div class="CookiesRowSpacer"></div>
        <div class="W-100">
          <span>{{LanguageSelector('Choose Main Area', 'اختر منطقة رئيسية')}}</span>
          <CookiesDropDown :Type="'Object'" :Selector="'Name'" :Radio="true" :IndexSelect="index" :Options="CookiesDataAreas" :Res="'New_SubArea_MainArea'"></CookiesDropDown>
        </div>
        <div class="CookiesRowSpacer"></div>
        <div class="W-100">
          <span>{{LanguageSelector('Choose Line', 'اختر خط')}}</span>
          <CookiesDropDown :Type="'Object'" :Selector="'Name'" :Radio="true" :IndexSelect="index" :Options="CookiesDataLines" :Res="'New_SubArea_Line'"></CookiesDropDown>
        </div>
      </div>
    </div>
  </div>
</div>
<div v-if="Access('AreasAdd')" class="CookiesDialogFooter">
  <div class=" F-Bold" style="margin: auto 1em;">
    <button @click="$router.go(-1)" style="background: var(--colorr1);" class="F-Bold CookiesButton DialogFooterButton">{{Translate('Cancel')}}</button>
    <button @click="SaveArea()" :style="'background: ' + Theme.UserColors.main" class="F-Bold CookiesButton DialogFooterButton">{{Translate('Save')}}</button>
  </div>
</div>

</template>

<script>
export default {
  data () {
    return {
      Name: '',
      ErrorsVisibilty: false,
      CookiesDataLines: [],
      CookiesDataAreas: [],
      Saving: false
    }
  },
  props: {
    DialogIndex: Number,
    DialogData: { default: '' }
  },
  methods: {
    ReadAreas () {
      this.Get('Area').then(response => {
        this.CookiesDataAreas = response
      }, error => {
        error.CookiesError = 'Error in reading Areas'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    ReadLines () {
      this.Get('Area/getLine').then(response => {
        this.CookiesDataLines = response
      }, error => {
        error.CookiesError = 'Error in reading Areas'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    SaveArea () {
      if (this.DialogError.length > 0) {
        this.ErrorsVisibilty = true
        return
      }
      this.Saving = true
      this.Post('POST', 'SubArea', this.NewAreaData).then(response => {
        this.Saving = false
        this.CloseDialog(this.DialogIndex)
      }, error => {
        this.Saving = false
        error.CookiesError = 'Error in Adding New Area'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    }
  },
  mounted () {
    if (!this.Access('AreasAdd')) {
      return
    }
    this.ReadAreas()
    this.ReadLines()
    try {
      var DialogPos = document.getElementById('CookiesDialog_' + this.DialogIndex).offsetTop - 60
      window.scrollTo(0, DialogPos)
    } catch (error) {
      console.log('error: ', error.message)
    }
  },
  computed: {
    NewAreaData () {
      this.Console(this.$store.state.CookiesMemory.New_SubArea_Line, 'color: blue, font-size: 2em;')
      this.Console(this.$store.state.CookiesMemory.New_SubArea_MainArea, 'color: blue, font-size: 2em;')
      return {
        Name: this.Name,
        LineID: this.$store.state.CookiesMemory.New_SubArea_Line.ID,
        AreaID: this.$store.state.CookiesMemory.New_SubArea_MainArea.ID
      }
    },
    DialogError () {
      var DialogErrors = []
      this.Name === '' && DialogErrors.push('Please Enter Area\'s Name')
      return DialogErrors
    },
    isActive () {
      return this.$store.state.CookiesMemory.D_NewArea_Active
    }
  }
}
</script>

<style scoped>
.DialogBody{
  width: 600px;
  max-width: 65vw;
}
.DialogContainer{
  padding: 50px;
}
@media (max-width: 500px) {
  .FlexBreaker{
    flex-direction: column;
  }
  .FlexBreaker > *{
    width: 80% !important;
  }
  .DialogContainer{
    padding: 1em;
  }
  .CookiesDialogdBody{
    font-size: 3vw;
  }
}
@media (max-width: 300px) {
  .CookiesDialogdBody{
    font-size: 4vw;
  }
}
.CookiesInputHolder{
  height: 30px;
  width: 200px;
  border: none;
  border-radius: var(--rad2);
  flex: auto;
  padding: 10px 25px;
  outline: none;
  font-size: 17px;
  margin: 6px;
  position: relative;
}

.CookiesInputInside::placeholder{
  opacity: 0.35;
}
.CookiesRowSpacer{
  width: 100%;
  height: 20px;
}

.CookiesNumberInput{
  display: flex;
  margin: auto;
  border-radius: var(--rad3);
  overflow: hidden;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.ErrorBorder{
  border: solid var(--colorr2) 2px;
  padding: 8px 23px;
}
</style>
